<template>
  <div class="columns is-multiline is-centered">
    <div class="column is-12">
      <div class="table-container-v3">
        <table class="table table-v3 is-fullwidth is-striped">
          <thead>
            <tr>
              <th><center>ID</center></th>
              <th><center>Nombre comercial</center></th>
              <th><center>Tipo</center></th>
              <th><center>Fecha de creación</center></th>
              <th><center>Detalle</center></th>
            </tr>
          </thead>
          <tbody v-if="!isLoading && offices">
            <tr
              v-for="item in offices"
              :key="item.id"
              class="is-new"
            >
              <td class="has-text-centered">
                <div class="-gray">{{ item.id }}</div>
              </td>
              <td class="has-text-centered">
                <a @click="goToLink(item.id)">{{ item.name }}</a>
              </td>
              <td class="has-text-centered">
                <div class="-gray">{{ item.officeType }}</div>
              </td>
              <td class="has-text-centered">
                <div class="-gray">{{ humanDate(item.createdAt, 'DD-MMMM-YYYY', false, 'es') }}</div>
              </td>
              <td class="has-text-centered">
                <div class="-gray">
                  <i @click="goToLink(item.id)" class="fas fa-plus-circle -upload-icon -blue pointer" />
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr v-for="index in 6" :key="index">
              <td v-for="item in 6" :key="item">
                <div class="-loading-text -w100" :class="{ delay: index % 2 == 0 }"></div>
              </td>
            </tr>
          </tbody>
          <tbody v-if="(!isLoading && offices.length === 0)">
          <tr>
            <td colspan="5" class="has-text-centered -text3 -gray">
              Sin información
            </td>
          </tr>
        </tbody>
        </table>
      </div>
    </div>
    <div class="column is-12 has-text-centered">
      <paginator
        :page="pagination.pageNumber"
        :pages="pagination.totalPages"
        :loading="false"
        :action="getListOffices"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'Branches',
  mixins: [mixins],
  components: {
    Paginator: () => import('@/components/ui/BasePagination.vue')
  },
  data () {
    return {
      showModal: false,
      offices: [],
      pagination: {
        pageNumber: 1,
        perPage: 10,
        totalPages: 1
      },
      isLoading: false
    }
  },
  mounted () {
    this.emitTitleAction()
    this.getListOffices()
  },
  methods: {
    ...mapActions(['getOffices']),
    emitTitleAction () {
      this.$emit('update-title-action', {
        label: 'Nueva sucursal',
        visible: true,
        disabled: true,
        handler: this.openCreateModal
      })
    },
    openCreateModal () {},
    async getListOffices (page) {
      const pagination = await this.getOffices({ pageNumber: page, perPage: 10 })
      this.pagination = pagination.pagination
      this.offices = pagination.data.getOffices.offices
    }
  }
}
</script>
